import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, ViewChild, ElementRef, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {ConfigStateService} from "../../../../../app/config/config-state.service";
import { ClientService, TaxReturnService } from "../../../../../../swaggerServices";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TenantConfigService } from "../../../../services/tenant-config.service";
declare const $: any;

@Component({
    selector: "add-to-batch",
    templateUrl: "./add-to-batch.component.html",
    styleUrls: ["./add-to-batch.component.scss"],
    standalone: false
})
export class AddToBatch implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentBatchList;
  @Input() selectedBatchFilter;
  @Input() taxReturnAlias: string;
  @Output() completed = new EventEmitter();
  selectedBatchId: number; // new batch input
  showModal = true;
  responseData = [];
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";
  batchDropdownObj;
  @ViewChild("batchDropdown") batchDropdown: ElementRef;

  private unsubscribe: Subject<void> = new Subject();
  constructor(
              private taxReturnService: TaxReturnService,
              private clientService: ClientService,
              @Optional() private dialogRef?: MatDialogRef<AddToBatch>,
              @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<AddToBatch>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.selectedBatchId || this.bulkActionState==='LOADING'
  }

  ngOnInit() {

      this.bulkActionState = 'OPENED';
      this.errorMessage = '';
      if (!this.currentBatchList.length) {
        this.errorMessage = 'Client has no batch';
        return;
      }     
      if(this.selectedBatchFilter > 0){
        this.errorMessage = `You need to remove these ${this.taxReturnAlias} from the selected batch, before you can add them to a another batch.`
      }
      setTimeout(() => {
        this.populateBatches();
      }, 100); 
    }
  
    populateBatches(){
      if (
        this.batchDropdown &&
        this.batchDropdown.nativeElement
      ) {
        this.batchDropdownObj = $(
          this.batchDropdown.nativeElement
        ).dropdown({
          values: this.currentBatchList.map(b => ({value: b.id, name: b.name})),
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedBatchId = +value;
            }
          }
        });
      }
    }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  createBatch() {
    
    this.errorMessage = '';
    this.bulkActionState = 'LOADING';
      this.clientService.addTaxReturnsToBatch({  batchId: this.selectedBatchId, taxReturnIds: this.selectedTaxReturnIds})
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.bulkActionState = 'COMPLETED';
      }, error => {
        this.errorMessage = "Something went wrong, please check error message and try again.";
        this.bulkActionState = 'OPENED';
        return;
      });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
